import { render, staticRenderFns } from "./faq-question.vue?vue&type=template&id=ad582794&lang=pug&"
import script from "./faq-question.vue?vue&type=script&lang=js&"
export * from "./faq-question.vue?vue&type=script&lang=js&"
import style0 from "./faq-question.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports